// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"../../colors.css\"","easilBlue":"#3184fc","teamCreateButtonWrapper":"style_teamCreateButtonWrapper__3g157","teamCreateTitle":"style_teamCreateTitle__13pUb"};